/**
 * Feature flags
 * TODO: Apps specific FF should be outside of the platform package, this is here for now to help fix circular deps
 */
const FEATURE_FLAGS = {
  ACTIVE_RESPONSE: true,
  ACTIVE_RESPONSE_TEST_ENV: undefined,
  ACTIVE_RESPONSE_GOOGLE_WORKSPACE_TENANT: undefined,
  ACTIVE_RESPONSE_AURORA_ENDPOINT: undefined,
  ACTIVE_RESPONSE_GENERIC_FIREWALL_EDL: undefined,

  THREAT_INTEL_SKU: true, // https://arcticwolf.atlassian.net/browse/PB-7436

  // AWN-303740
  ADS_ASSETS: true,
  ADS_FULL_MOCKED: undefined,
  ADS_ASSET_TAGS: undefined,

  // AWN-1022275
  ADS_RISK_ADDITIONS: true,
  ADS_GA_RELEASE: true,

  // AWN-173958
  AGENTS_MODULE_INSTALLATION: true,

  // S2CX-354
  DATA_EXPLORER_VISUALIZATION: true,

  // AWN-320841
  DETECTION_CATALOG_V2: true,
  DETECTION_CATALOG_PHASE_3: undefined,
  DETECTION_CATALOG_EXPORT: undefined,
  DETECTION_CATALOG_TEST_ENV_REQUIRES_VPN: undefined,

  // AWN-136327
  ENHANCED_SCANNER_VIEW: undefined,

  EVENT_LOG_EVENTS_SOURCE: undefined, // S2CX-2980

  // AWN-220282 - Add hyper-v awn1000
  HYPER_V_1000_DOWNLOAD: undefined,

  // MR-1928 remove last scan column
  IVA_LAST_SCAN_UPDATE: undefined,

  // AWN-990795 Add FF for vlc HA frontend
  LOG_COLLECTION_HA: true,

  // SSC-3373 - Provide access to Nutanix vScanner image
  NUTANIX_SCANNER_DOWNLOAD: undefined,

  // AWN-226899 - Check recent Scanner jobs for issues
  SCANNER_ERR_BANNER: undefined,

  // S2CX-4939 - Scanner Configure and Activate
  SCANNER_CONFIGURE_ACTIVATE: undefined,

  // AWN-281143 - Go Back button on Detection Detail Page With V2 FF
  UNIFIED_CONTENT_LIBRARY_V2: undefined,

  // AWN-167523 Risks in Unified Portal
  RISKS_IN_UP_M1: undefined,
  RISKS_IN_UP_WIP: undefined,
  RISK_IN_UP_LIVE_TEST_DATA: undefined,

  // AWN-218319 Address Autofill Input -- Site Telemetry
  SITE_TELEMETRY_ADDRESS_AUTOFILL: true,

  // S2CX-6440 Create Custom Dashboard - Insights
  INSIGHTS_CREATE_CUSTOM_DASHBOARD: undefined,

  DATA_EXPLORER_IMPROVED_SEARCH: undefined,

  CUSTOM_ALERTS: undefined,

  // Cipher AI Bog
  CIPHER_CHATBOT: undefined,

  // Foxhound
  SSC_SELF_SERVICE_UPGRADE: undefined,
  SSC_SELF_SERVICE_UPGRADE_RBAC_BYPASS: undefined,

  SHOW_AGENT_SETTINGS_PAGE: undefined,
  SHOW_AGENT_ALLOWLIST_TAB: undefined,

  ZOOMIN: undefined,

  AGENTS_TABLE_V2: undefined,

  // LABS-471 Blocklist Downloads
  BLOCKLIST_DOWNLOAD: true,

  // PLAT-2627 Access Control Feature
  ACCESS_CONTROL: undefined,

  CYBER_RESILIENCE_ASSESSMENT: undefined,

  // S2CX-374: Allow customers to manager their escalation configs
  SELF_SERVE_ESCALATIONS: undefined,

  SCAN_SCHEDULES_TABLE_V2: undefined,

  // S2CX-10400: Add a "What's new" section to the app bar
  WHATS_NEW: true,

  // S2CX-3325: New Onboarding Experience in Unified Portal
  NEW_ONBOARDING_EXPERIENCE: undefined,
  // IRR-801: Create Incident Response Feature
  INCIDENT_RESPONSE: undefined,

  // PLAT-5202: Migrating Assets components to Fenrir V2
  // TODO: Remove this FF once the PLAT-8375 is resolved
  ADS_ASSETS_OPTIONAL_COLUMNS: undefined,

  //S2CX-14799 Add Primary Technical Domain to SPiDR Blueprint Tables
  PRIMARY_TECHNICAL_DOMAIN: true,

  // S2CX-12919 Allow toggling between API and fixtures until the API is fully implemented
  USE_EVIDENCELOCKER_API: false,

  //PLAT-7874: Migrating assets filters from custom component to Data Grid Filters
  ADS_FILTERS_V2: undefined,
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;
export type FeatureFlagsRecord = Record<FeatureFlagKey, boolean>;

export const KEYS = Object.keys(FEATURE_FLAGS).sort() as FeatureFlagKey[];

export const initFeatureFlags = (flags = FEATURE_FLAGS) => {
  Object.entries(flags).forEach(([flag, value]) => {
    if (value === undefined) return;

    if (value) {
      window.localStorage.setItem(flag, JSON.stringify(value));
    } else {
      window.localStorage.removeItem(flag);
    }
  });
};
